import { useMemo, useRef } from 'react'

import { errorView, useWindow } from '@krp/client-runtime'
import { CreateDefaultsScreen, aqsiCreateDefaults, aqsiSaveCreateDefaults } from '@krp/resource-aqsi-ui'
import { StatusMessage } from '@krp/ui-kit'

import { useAppSelector } from '../../app/hooks'

/** «Создание по умолчанию» источника AQSI (RP-SYN12): умолчания ресурса из адреса окна. */
export function AqsiCreateDefaultsBinding() {
  const window = useWindow()
  const resourceId = window.params.rid ?? ''
  return <CreateDefaults key={resourceId} resourceId={resourceId} />
}

function CreateDefaults({ resourceId }: { resourceId: string }) {
  const args = useMemo(() => ({ resourceId }), [resourceId])
  const subscription = aqsiCreateDefaults.useQuerySubscription(args, { skip: resourceId === '', refetchOnMountOrArgChange: true })
  const select = useMemo(() => aqsiCreateDefaults.select(args), [args])
  const result = useAppSelector(select)
  const [save, mutation] = aqsiSaveCreateDefaults.useMutation()
  const sending = useRef(false)
  if (resourceId === '') return <StatusMessage kind="error" title="Нужен источник AQSI в адресе окна" />
  const rawError = mutation.error ?? result.error
  const error = rawError === undefined ? null : errorView(rawError)
  const data = result.isError ? null : result.data ?? null
  return <CreateDefaultsScreen
    key={`${resourceId}:${data?.version ?? 'loading'}`}
    data={data}
    busy={mutation.isLoading || result.isLoading}
    error={error === null ? null : { message: error.message, meta: `Код: ${error.code} · запрос ${error.correlationId ?? '—'}` }}
    saved={mutation.isSuccess}
    onReload={() => { mutation.reset(); void subscription.refetch() }}
    onSave={(values) => {
      if (sending.current || data === null) return
      sending.current = true
      void save({ resourceId, values, expectedVersion: data.version }).finally(() => { sending.current = false })
    }}
  />
}
